import Marquee from "react-fast-marquee";
import { CMYK } from "../lib/data";

const words = ["PRECISION", "CRAFT", "TANGIBLE", "INK", "PAPER", "HIGH-VOLUME OFFSET"];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="border-b border-black py-8 md:py-12 overflow-hidden bg-[#F4F4F0]">
    <Marquee speed={30} autoFill gradient={false}>
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-bold uppercase text-6xl md:text-8xl tracking-tight text-stroke mx-6">
            {w}
          </span>
          <span className="text-4xl md:text-6xl mx-2" style={{ color: CMYK[i % 4] === "#0E0E0E" ? "#FF3B30" : CMYK[i % 4] }}>
            •
          </span>
        </span>
      ))}
    </Marquee>
  </div>
);
